import { faPhone } from "@fortawesome/free-solid-svg-icons"
import Icon from "../Icon"
import Location from '../../assets/images/card/4.png'
import { convertTo12HourFormat } from "../../utils"
import useWidth from "../../hooks/useWidth"
import { Link } from "react-router-dom"


export default ({ data = {} }) => {
    const width = useWidth()

    return (
        width > 992 ?
        <div className='row trending-card mx-3'>
            <div className="col-8 p-0 " >
                <p className='mb-0 ms-4' style={{ fontSize: "70px", fontWeight: "750", color: "#3487f4" }}>Trending</p>
                <div className='bg-warning p-3' style={{ marginTop: "-24px", borderRadius: "16px 100px 0px 0px", height: "12rem" }}>
                    <h3 className='custom-text-color'>{ data.title }</h3>
                    <p className='fs-9 mb-4'>{ data.description }</p>
                </div>
            </div>
            <div className="col-4 p-0 bg-warning " style={{ borderRadius: "16px 16px 0px 0", zIndex: 1 }}>
                <div className='m-3 border border-1 rounded-4'>
                    <p className='p-2 border-bottom border-1'>Travel Details</p>
                    <div className="d-flex justify-content-between p-2">
                        <div>
                            <p className=' mb-1 fs-9 bold'>Departure From:</p>
                            <p className=' mb-1 fs-9 bold'>Departure Date:</p>
                            <p className=' mb-1 fs-9 bold'>Departure Time:</p>
                            <p className=' mb-1 fs-9 bold'>Package Cost:</p>
                            <br/>
                            <p className=' mb-1 fs-9 bold'>Duration:</p>
                        </div>
                        <div>
                            <p className=' mb-1 fs-9'>{ data.departure_from }</p>
                            <p className=' mb-1 fs-9'>{ new Date(data.departure_date)?.toLocaleDateString()}</p>
                            <p className=' mb-1 fs-9'>{ data.departure_time && convertTo12HourFormat( data.departure_time )}</p>
                            <p className=' mb-1 fs-9'>{ data.packageCost?.map( pack => <>₹{ pack.cost } { pack.package } <br/></>)}</p>
                            <p className=' mb-1 fs-9'>{ data.duration } Days</p>
                        </div>
                    </div>
                    <div className="p-2">
                        <Link to={`/tours-events/${ data._id || data.id }`} className=''>
                            <button className='primary-btn py-1 w-100'>Book Now</button>
                        </Link>
                    </div>
                </div>
            </div>
            <div className="col-12 p-0 bg-warning " style={{ marginTop: "-45px", borderRadius: "0px 0px 16px 16px" }}>
                <div className='p-3 d-flex '>
                    <div style={{ width: "170px", height: "200px" }}>
                        <img src={data.files?.at(0)?.Url || Location} className='w-100 h-100 image-cover rounded-4' />
                    </div>
                    <div className='ms-3 w-25' >
                        <p className='mb-2 custom-text-color bold'>What we do:</p>
                        {
                            data.plans?.map(( plan, i ) => 
                                <>
                                    <p className='fs-9 bold custom-text-color mb-0 '>Day-{ plan.day } ({ plan.destination })</p>
                                    <p className='fs-9 mb-1 plan-description'>{ plan.description }</p>
                                </>
                            )
                        }
                    </div>
                    <div className='card rounded-4 mt-5 w-50'>
                        <h6 className='custom-text-color text-center my-2'>Do you have any question?</h6>
                        <hr className='my-1' />
                        <div className='d-flex flex-column align-items-center justify-content-center  mt-2'>
                            <div className='w-75'>
                                <p className='fs-9 mb-3 custom-text-color'>Feel free to give us a call. We are a team of experts and would be happy to assist you. </p>
                                <button className='primary-btn   fs-9 w-100'><Icon icon={faPhone} className="me-2" />+91 1234567890</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        :
        <section className="overflow-auto scrollbar-hidden ms-2">
            <div className="row w-100">
                <div className="col-12 m-0">
                    <div className="card bg-warning rounded-4 p-2 d-flex flex-column justify-content-between" style={{ height: "250px"}}>
                        <div className="d-flex">
                            <div className="" style={{ width: "250px", height: "150px" }}>
                                <img src={ data.files?.at(0)?.Url } className="w-100 h-100 image-cover rounded-4" />
                            </div>

                            <div className="w-100 ms-2">
                                <h5 className="mb-1 fs-6 text-end text-primary " style={{ fontStyle: "italic", fontWeight: "600" }}>#Trending</h5>
                                <h5 className='custom-text-color'>{ data.title }</h5>
                                <p className="mb-0" style={{ maxHeight: "120px", overflow: "hidden"}}>{ String(data.description)?.substring(0, 90) }</p>
                            </div>
                        </div>
                        <div className="p-2">
                        <Link to={`/tours-events/${ data.id }`} className=''>
                            <button className='primary-btn py-1 w-100'>Book Now</button>
                        </Link>
                    </div>
                    </div>
                </div>
            </div>
        </section>
    )
}